<template>
    <img :id="ids.type" :src="source" :alt="`Logo - ${CONFIG.project.name}`" :title="CONFIG.project.name" :width="size" :height="size"/>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";
import { Animation } from "@/assets/JS/Animation.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import $ from "jquery";
import store from "@/store";

export default {
    name: "Logo",
    props: {
        type: String,
        size: Number
    },
    data: () => ({
        source: "",
        CONFIG,
        ids: { type: "" }
    }),
    methods: {
        GetSource: function() {
            let source = "";
            switch(this.type) {
                case "Intro":
                    source = "LogoTitled.png";
                    break;
                case "Emblem":
                    source = "LogoEmblem.png";
                    break;
            }
            this.source = require(`@/assets/Images/${source}`);
        },
        Animate: function() {
            const $logo = $("#logo-animated");
            const component = this;
            new Animation($logo, "Fade", 1, 1000, 2000, function() {
                new Animation($logo, "Fade", 0, 1000, 3500, function() {
                    component.$emit("loaded");
                    store.state.loaded = true;
                    ASSETS.SetStorage("Portfolio", store.state);
                });
            });
        },
        TypeIntro: function() { return this.type === "Intro"; }
    },
    beforeMount: function() {
        this.GetSource();
        this.ids.type = this.TypeIntro() ? "logo-animated" : "logo";
    },
    mounted: function() {
        if (this.TypeIntro()) {
            this.Animate();
        }
    },
    emits: [ "loaded" ]
};
</script>